// extracted by mini-css-extract-plugin
export default {"your_rd":"UA","title":"VA","subtitle":"WA","rd_bio_wrapper":"XA","rd_text_mobile":"YA","rd_bio":"ZA","img":"aB","rd_info":"bB","rd_name":"cB","rd_stat":"eB","rd_text":"fB","btn_mobile":"gB"};
    if(module.hot) {
      // 1715632475624
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  